import type { CSSProperties } from "react";
import { Toaster } from "sonner";

const TOASTER_WIDTH = {
  "--width": "min(440px, calc(100vw - 2rem))",
} as CSSProperties;

const TOAST_BASE = [
  "group pointer-events-auto relative flex w-full items-center gap-3",
  "rounded-2xl border py-3.5 pl-4 pr-10",
  "shadow-dropdown ring-1 ring-inset ring-white/20",
  "backdrop-blur-2xl backdrop-saturate-150",
].join(" ");

const ICON_TILE = [
  "relative grid h-8 w-8 shrink-0 place-items-center self-center rounded-xl",
  "[&>svg]:h-[18px] [&>svg]:w-[18px]",
  "[&_.sonner-loading-wrapper]:!inset-auto [&_.sonner-loading-wrapper]:!relative",
  "[&_.sonner-loading-bar]:bg-current",
].join(" ");

/**
 * Los toast.custom traen su propia tarjeta, así que el envoltorio de sonner
 * tiene que desaparecer o se ven dos fondos superpuestos.
 */
export const CUSTOM_TOAST_OPTIONS = {
  duration: Infinity,
  classNames: {
    toast: "!border-0 !bg-transparent !p-0 !shadow-none !backdrop-filter-none",
  },
} as const;

export function AppToaster() {
  return (
    <Toaster
      position="top-center"
      style={TOASTER_WIDTH}
      offset={20}
      gap={10}
      visibleToasts={4}
      closeButton
      toastOptions={{
        unstyled: true,
        duration: 5000,
        classNames: {
          toast: TOAST_BASE,
          title: "font-display text-sm font-semibold leading-snug text-content",
          description: "mt-0.5 text-[13px] leading-relaxed text-content-secondary",
          icon: ICON_TILE,
          closeButton:
            "!left-auto !right-2 !top-1/2 !-translate-y-1/2 grid h-6 w-6 place-items-center rounded-full !border-0 !bg-transparent text-content-muted transition-colors hover:!bg-content/10 hover:text-content [&>svg]:h-3.5 [&>svg]:w-3.5",
          actionButton:
            "ml-auto shrink-0 self-center rounded-lg bg-primary-500 px-3 py-1.5 text-xs font-medium text-on-primary transition-colors hover:bg-primary-400",
          cancelButton:
            "shrink-0 self-center rounded-lg border border-line bg-card px-3 py-1.5 text-xs font-medium text-content-secondary transition-colors hover:bg-subtle",
          default:
            "bg-card/70 border-line-soft [&_[data-icon]]:bg-subtle [&_[data-icon]]:text-content-secondary",
          loading:
            "bg-card/70 border-line-soft [&_[data-icon]]:bg-subtle [&_[data-icon]]:text-content-secondary",
          success:
            "bg-success-50/70 border-success-200 [&_[data-icon]]:bg-success-100 [&_[data-icon]]:text-success",
          error:
            "bg-error-50/70 border-error-200 [&_[data-icon]]:bg-error-100 [&_[data-icon]]:text-error",
          warning:
            "bg-warning-50/70 border-warning-200 [&_[data-icon]]:bg-warning-100 [&_[data-icon]]:text-warning",
          info: "bg-info-50/70 border-info-200 [&_[data-icon]]:bg-info-100 [&_[data-icon]]:text-info",
        },
      }}
    />
  );
}
